<template>
    <article id="app" class="ifr__dementia">
        <Intro/>
        <MapData/>
        <Signals/>
        <Stories/>
        <Risk/>
        <Social/>
    </article>
</template>
<script>
import Intro from '@/components/Intro'
import MapData from '@/components/MapData'
import Signals from '@/components/Signals'
import Stories from '@/components/Stories'
import Risk from '@/components/Risk'
import Social from '@/components/Social'
export default {
    name: 'app',
    components: {
        Intro,
        MapData,
        Signals,
        Stories,
        Risk,
        Social
    }
}
</script>